import { HttpClient } from './http-client';

export class HttpClientProvider {
  /**
   * The instance of http client.
   */
  static _instance;

  /**
   * Creates a singleton instance of http client.
   */
  static getInstance() {
    if (!HttpClientProvider._instance) {
      HttpClientProvider._instance = new HttpClient();
    }

    return HttpClientProvider._instance;
  }
}
